<template>
  <component
    :is="selectedComponent"
    v-if="pdpMessage"
    :show-icon="showProviderIcon"
    :price="price"
    :provider-name="pdpMessage.provider"
    :payment-months="pdpMessage.instalments"
    class="provider"
  />
</template>

<script>
import { mapGetters } from "vuex";
import { paymentMethods } from "@/config.js";
import Clearpay from "@/components/product-display/bnpl-providers/ClearpayV2.vue";
import Klarna from "@/components/product-display/bnpl-providers/KlarnaV2.vue";

export default {
  name: "BNPLInformation",
  components: {
    Clearpay,
    Klarna,
  },
  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    ...mapGetters("product", ["price"]),
    pdpMessage() {
      return paymentMethods[this.currencyCode]?.pdpMessage || null;
    },
    selectedComponent() {
      const provider = this.pdpMessage?.provider?.toLowerCase();

      if (provider === "klarna") {
        return "Klarna";
      }

      if (provider === "clearpay" || provider === "afterpay") {
        return "Clearpay";
      }

      return null;
    },
    showProviderIcon() {
      const provider = this.pdpMessage?.provider?.toLowerCase();

      return this.showIcon && provider !== "afterpay";
    },
  },
};
</script>

<style lang="scss" scoped>
.provider {
  display: flex;
  align-items: center;
  justify-content: center;
  @include t__utility-body-10;

  img {
    margin-left: 6px;
  }
}
</style>
